"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_CODES = void 0;
var KEY_CODES = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40
});
exports.KEY_CODES = KEY_CODES;